import { apiRequest } from "../services/apiRequest";

export const AnnouncementsApi = {
  getAnnouncements: async (page = 1, pageSize = 10, cacheBust) => {
    const params = new URLSearchParams();
    if (page) params.set("page", page);
    if (pageSize) params.set("page_size", pageSize);
    if (cacheBust) params.set("_ts", cacheBust); // cache-bust to avoid local GET cache
    const query = params.toString();
    return await apiRequest(
      "get",
      `/account/announcements/${query ? `?${query}` : ""}`
    );
  },
  createAnnouncement: async (payload) => {
    return await apiRequest("post", "/account/announcements/", payload);
  },
  deleteAnnouncement: async (announcementId) => {
    return await apiRequest(
      "delete",
      `/account/announcements/${announcementId}/`
    );
  },
};

